import { EActiveView } from '../../types/view';
import { EEventType } from '../../types/events';
import { ECreateError, ECreateStatus } from '../../types/social';
import { SOCIAL_CREATE_TYPE } from '../../constants/action_types';
import { changeView } from '../view';
import { authenticate } from './authenticate';
import { getIgnoreSocialDataForRegistration } from './getIgnoreSocialDataForRegistration';
import { trackSocialCreateCreateClick } from '../../utils/tracking';
import { fetchCreateUser } from '../../repositories/social-users/v1/create-user';
import { emailSelector, phoneSelector } from '../../selectors/social';
import { sourceSelector } from '../../selectors/source';
export function create() {
  return function (dispatch, getState, context) {
    var config = context.config,
      httpApi = context.httpApi;
    dispatch({
      type: SOCIAL_CREATE_TYPE,
      status: ECreateStatus.Loading
    });
    var state = getState();
    var email = emailSelector(state);
    var phone = phoneSelector(state);
    var source = sourceSelector(state);
    var _state$social = state.social,
      socialType = _state$social.socialType,
      socialLoginId = _state$social.socialLoginId,
      _state$agreement = state.agreement,
      licenceAccepted = _state$agreement.licenceAccepted,
      marketingSubscriptionAccepted = _state$agreement.marketingSubscriptionAccepted,
      view = state.view;
    if (!socialType || !socialLoginId) {
      throw new Error('Either socialType or socialLoginId is not present');
    }
    var ignoreSocialDataForRegistration = getIgnoreSocialDataForRegistration(socialType, config);
    return fetchCreateUser({
      httpApi: httpApi,
      parameters: {
        socialLoginId: socialLoginId,
        email: email,
        phone: phone,
        ignoreSocialDataForRegistration: ignoreSocialDataForRegistration,
        isAcceptLicence: licenceAccepted,
        hasMarketingSubscriptions: marketingSubscriptionAccepted
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(function (response) {
      if (response.statusCode === 200) {
        var _socialLoginId = response.response.socialLoginId;
        var _email = response.response.email || '';
        var token = response.response.token || '';
        dispatch({
          type: SOCIAL_CREATE_TYPE,
          status: ECreateStatus.Succeed
        });
        trackSocialCreateCreateClick({
          source: source
        });
        dispatch(authenticate({
          socialType: socialType,
          socialLoginId: _socialLoginId,
          email: _email,
          token: token,
          userCreated: true,
          source: source
        }));
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(function (error) {
        return error.code === 'existed_email';
      })) {
        dispatch({
          type: SOCIAL_CREATE_TYPE,
          status: ECreateStatus.Failed,
          errorType: ECreateError.MergeRequired,
          error: response.response.message,
          email: email
        });
        dispatch(changeView(EActiveView.SocialMerge, {
          prevView: EActiveView.SocialCreate
        }));
        context.emitter.emit(EEventType.SocialAuthenticateEmailTaken, {
          type: socialType
        });
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(function (error) {
        return error.code === 'LicenceDoesNotAccepted';
      })) {
        dispatch({
          type: SOCIAL_CREATE_TYPE,
          status: ECreateStatus.Failed,
          errorType: ECreateError.LicenceNotAccepted,
          error: response.response.message
        });
        dispatch(changeView(EActiveView.Agreement, {
          prevView: view.active,
          prevData: view.data
        }));
        return;
      }
      dispatch({
        type: SOCIAL_CREATE_TYPE,
        status: ECreateStatus.Failed,
        errorType: ECreateError.Common,
        error: response.response.message
      });
      dispatch(changeView(EActiveView.SocialCreate));
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialCreate',
        socialType: socialType
      });
      dispatch({
        status: ECreateStatus.Failed,
        type: SOCIAL_CREATE_TYPE,
        errorType: ECreateError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
      dispatch(changeView(EActiveView.SocialCreate));
    });
  };
}